const Links = () => {
    return (
        <main style={{ gap: "1rem" }}>
            <h1>LINKS</h1>
            <div className="dev-container">
                <a
                    className="external-item"
                    href="https://eu-west-2.console.aws.amazon.com/console/home?region=eu-west-2"
                >
                    AWS Login
                </a>

                <a className="external-item" href="https://trello.com/login" target="_blank">
                    Trello
                </a>

                <a className="external-item" href="https://app.timetastic.co.uk/calendar" target="_blank">
                    Timetastic
                </a>

                <a className="external-item" href="http://35.176.50.20:8080/" target="_blank">
                    Jenkins
                </a>

                <a className="external-item" href="https://www.crucibledev.net/phpmyadmin/" target="_blank">
                    phpMyAdmin
                </a>

                <a className="external-item" href="https://rollbar.com/login/" target="_blank">
                    Rollbar
                </a>

                <a className="external-item" href="https://slack.com/signin/" target="_blank">
                    Slack
                </a>

                <a className="external-item" href="https://crucible.testrail.com/" target="_blank">
                    TestRail
                </a>

                <a
                    className="external-item"
                    href="https://tracker.gaminglabs.com:8443/secure/Dashboard.jspa"
                    target="_blank"
                >
                    GLI JIRA
                </a>

                <a className="external-item" href="https://tu.enea.sk/" target="_blank">
                    TextureUnpacker
                </a>
            </div>
        </main>
    );
};

export default Links;
